<template>
  <div />
</template>

<script>

/**
 * Vue: Account pages (account-pages)
 * -----------------------------------------------------------------------------
 * Global modal for Account pages.
 *
 */
import { mapActions } from 'vuex'

export default {
  name: 'AccountPages',

  components: {
  },

  props: {
  },

  mounted() {
    this.setNodeSelectors()
    this.setEventListeners()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      openOverlay: 'overlays/open',
    }),

    /**
     * Set node selectors.
     */
    setNodeSelectors() {
      this.nodeSelectors = {
        customerNavMobileTrigger: [...document.querySelectorAll('[js-customers-navigation-mobile]')],
      }
    },

    /**
     * Set event listeners.
     */
    setEventListeners() {
      this.nodeSelectors.customerNavMobileTrigger.forEach((cta) => {
        cta.addEventListener('click', (event) => {
          this.handleCustomerNavMobileTrigger(event)
        })
      })
    },

    /**
     * Handle open wishlist drawer
     */
    handleCustomerNavMobileTrigger(event) {
      event.preventDefault()

      this.openOverlay({
        component: 'customers-navigation-mobile-drawer',
        ignoreDismissed: true,
        namespace: 'customersNavigationMobileDrawer',
      })
    },
  },
}
</script>
